import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
	ComposableMap,
	Geographies,
	Geography,
	Marker,
	ZoomableGroup,
} from 'react-simple-maps';

document.addEventListener('DOMContentLoaded', () => {
	// Define constants
	const mapHeight = 850;
	const mapWidth = 1440;
	const markerHeight = 34;
	const markerWidth = 34;

	const minZoom = 1.25;
	const maxZoom = 20;

	const container = document.getElementById('projects-map-root');
	if (!container) return;

	const script = document.getElementById('projects-map-data');
	const markers = script ? JSON.parse(script.textContent) : [];

	const geoUrl =
		'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

	const App = () => {
		const [zoom, setZoom] = useState(1.25);
		const [center, setCenter] = useState([10, 45]);

		const listExists = !!document.querySelector('.projects-list');

		const getVisibleProjectLinks = () => {
			return Array.from(document.querySelectorAll('.project-card')).map(
				(el) => el.href
			);
		};

		const [visibleLinks, setVisibleLinks] = useState(
			listExists ? getVisibleProjectLinks() : []
		);

		useEffect(() => {
			if (!listExists) return;

			const container = document.querySelector('.projects-list');
			if (!container) return;

			// const observer = new MutationObserver(() => {
			// 	setVisibleLinks(getVisibleProjectLinks());
			// });

			// observer.observe(container, { childList: true, subtree: true });
			// return () => observer.disconnect();
		}, [listExists]);

		const handleZoomIn = () => {
			setZoom((z) => Math.min(maxZoom, z * 1.4));
		};

		const handleZoomOut = () => {
			setZoom((z) => Math.max(minZoom, z / 1.4));
		};

		const handleMoveEnd = (pos) => {
			setZoom(pos.zoom);
			setCenter(pos.coordinates);
		};

		const filterAntarctica = (geographies) => {
			return geographies.filter((geo) => {
				try {
					const coords = geo.geometry.coordinates;

					const extractLats = (arr) => {
						let out = [];
						for (const item of arr) {
							if (typeof item[0] === 'number') {
								out.push(item[1]);
							} else {
								out = out.concat(extractLats(item));
							}
						}
						return out;
					};

					const lats = extractLats(coords);
					const maxLat = Math.max(...lats);

					return maxLat >= -40;
				} catch (e) {
					return true;
				}
			});
		};

		return (
			<div className="projects-map-container">
				<ComposableMap
					projection="geoMercator"
					projectionConfig={{
						scale: 160,
						center: [0, 80],
						rotate: [-10, 0, 0],
					}}
					width={1400}
					height={mapHeight}
				>
					<ZoomableGroup
						center={center}
						zoom={zoom}
						minZoom={minZoom}
						maxZoom={maxZoom}
						onMoveEnd={handleMoveEnd}
						animate={true}
						translateExtent={[
							[-200, 200],
							[mapWidth + 200, mapHeight + 300],
						]}
					>
						<Geographies geography={geoUrl}>
							{({ geographies }) =>
								filterAntarctica(geographies).map((geo) => (
									<Geography
										key={geo.rsmKey}
										geography={geo}
										style={{
											default: {
												fill: '#ffffff',
												stroke: '#1D2432',
												strokeWidth: 0.4,
												pointerEvents: 'none',
												outline: 'none',
											},
											hover: { fill: '#ffffff' },
											pressed: { fill: '#ffffff' },
										}}
									/>
								))
							}
						</Geographies>

						{markers
							.filter((m) => {
								if (!listExists) return true;
								if (visibleLinks.length === 0) return false; // TEMP
								return true; // TEMP
								//return visibleLinks.includes(m.link);
							})
							.map((m) => (
								<Marker key={m.id} coordinates={[m.lng, m.lat]}>
									<foreignObject
										x={-markerWidth / 2}
										y={-markerHeight / 2}
									>
										<a
											className="project-marker"
											href={m.link}
											target="_blank"
											rel="noopener noreferrer"
											style={{
												width: markerWidth + 'px',
												height: markerHeight + 'px',
												transform: `scale(${1 / zoom})`,
												transformOrigin: 'center',
											}}
										>
											<img
												className="brand-logo"
												src={m.icon}
												alt=""
											/>
										</a>
									</foreignObject>
								</Marker>
							))}
					</ZoomableGroup>
				</ComposableMap>

				<div className="projects-map-buttons">
					<button
						type="button"
						onClick={handleZoomIn}
						className="button outlined map-zoom-btn"
					>
						+
					</button>

					<button
						type="button"
						onClick={handleZoomOut}
						className="button outlined map-zoom-btn"
					>
						-
					</button>
				</div>
			</div>
		);
	};

	createRoot(container).render(<App />);
});
